import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import Cancel from "./../../../../assets/icons/close.png";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";

import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import LoadingView from "../../../components/LoadingView/LoadingView";

function CancelReasonDialog(props) {
  const handleClose = () => {
    props.onClose(false);
  };
  const [reasonDatas, setreasonDatas] = React.useState([]);
  const apiAddress = process.env.REACT_APP_SECRET;
  React.useEffect(() => {
    loadData();
  }, []);

  const [openSweetModal, SetOpenSweetModal] = React.useState(false);
  const [loadingModal, SetloadingModal] = React.useState(false);

  const SubmitApproval = async () => {
    SetOpenSweetModal(false);
    var validation = true;
    SetloadingModal(true);
    console.log("reason[0]: " + reason[0]);

    if (reason[0] == undefined) {
      toast.error("Error Reason Required !!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      validation = false;
    }

    if (restaurant[0] == undefined) {
      toast.error("Error Restaurant Name Required !!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      validation = false;
    }

    console.log("validation: " + validation);

    if (validation) {
      try {
        if (newReasons.length > 0) {
          console.log(newReasons.length);
          newReasons.map((dt, index) => {
            var reason = {
              id: dt.id,
              details: dt.title,
              isActive: true,
              creatorId: "1",
              creationDate: new Date(),
              modifierId: "1",
              modificationDate: new Date(),
            };
            axios({
              method: "post",
              url: apiAddress + "/api/CancelationReason",
              data: reason,
            });
            setnewReasons([]);
          });
        }
      } catch (error) {
        console.error(error);
      }

      var obj = {
        requestId: restaurant,
        cancelDatas: reason,
        descriptions: description,
        from: props.from,
      };

      const token = localStorage.getItem("gotasteadmintoken");

      if (token) {
      } else {
        window.location.href = "/login";
      }

      axios({
        method: "post",
        url: apiAddress + "/api/NewRestaturantRequest/cancelRestaurantRequests",
        data: obj,
        headers: {
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log(response);
          toast.success("Successfully Saved", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setReason([
            {
              id: "",
              title: "",
            },
          ]);
          setrestaurant({
            id: "",
            title: "",
          });
          loadData();
          SetloadingModal(false);
          props.onClose(false);
        })
        .catch(function (error) {
          console.log(error);
          SetloadingModal(false);
          toast.error("Error" + error, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  const loadData = async () => {
    await axios.get(apiAddress + "/api/CancelationReason").then((response) => {
      var tempData = [];
      response.data.map((data, index) => {
        var newData = {
          id: data.id,
          title: data.details,
        };
        tempData.push(newData);
      });
      setTempDatas(tempData);
      setreasonDatas(tempData);
    });
  };
  const resDatas = props.allRestaurant;
  const [reason, setReason] = React.useState([
    {
      id: "",
      title: "",
    },
  ]);
  const addValue = (props) => {
    console.log("Add Value: " + props);
    var datas = [];
    if (props.length > 0) {
      props.map((dt, index) => {
        // console.log(dt.id);
        // var obj = {
        //     id: index + 1 + "",
        //     title: dt
        // }
        // datas.push(obj);
        var data = reasonDatas.find((x) => x.title == dt);
        console.log(data);
        datas.push(data);
      });
      setReason(datas);
    } else {
      setReason([]);
    }
  };
  const [restaurant, setrestaurant] = React.useState(props.restaurantName);
  const addRestaurant = (props) => {
    console.log(props);
    setrestaurant(props);
  };
  const [description, setdescription] = React.useState("");
  const textFieldValue = (props) => {
    console.log(props);
    setdescription(props);
  };

  React.useEffect(() => {
    setreasonDatas(tempDatas);
  }, [reasonDatas]);

  const [tempDatas, setTempDatas] = useState([]);
  const [newReasons, setnewReasons] = useState([]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      const inputValue = event.target.value;
      console.log("inputValue: " + inputValue);
      // var val = keywordDatas;
      // val.push(inputValue);
      // setkeywordDatas(val);

      console.log("reasonDatas.length: " + reasonDatas.length);

      var obj = {
        id: uuidv4(),
        title: inputValue,
      };

      var newReasonTemp = newReasons;
      newReasonTemp.push(obj);
      setnewReasons(newReasonTemp);

      var val = reasonDatas;
      val.push(obj);
      setTempDatas(val);
      setreasonDatas([]);
      console.log("reasonDatas.length: " + reasonDatas);
    }
  };

  function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  React.useEffect(() => {
    setrestaurant(props.restaurantName);
  }, [props.restaurantName]);

  console.log(restaurant);
  console.log(props.restaurantName);

  const closeSweetModal = () => {
    SetOpenSweetModal(false);
  };
  const closeLoadingModal = () => {
    SetloadingModal(false);
  };
  return (
    <div>
      <ToastContainer />
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth="lg"
          open={props.open}
          onClose={handleClose}
        >
          <SweetAlertModal
            open={openSweetModal}
            onyes={SubmitApproval}
            close={closeSweetModal}
            headerText={"Are you sure?"}
            bodyText={"You want to reject this?"}
          />
          <LoadingView open={loadingModal} close={closeLoadingModal} />

          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>Cancel Reason</DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography
                    sx={{ paddingTop: "1.5rem", alignItems: "center" }}
                  >
                    Restaurant Name
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <AutoCompleteMultiSelect
                    label={"Restaurant Name"}
                    placeholder={"Restaurant Name"}
                    value={addRestaurant}
                    datas={resDatas}
                    defaultValue={props.restaurantName}
                    id={2}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography
                    sx={{ paddingTop: "1.5rem", alignItems: "center" }}
                  >
                    Reason
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  {/* <AutoCompleteMultiSelect
                                        label={'Reason'}
                                        placeholder={'Reason'}
                                        value={addValue}
                                        datas={reasonDatas}
                                        id={2}
                                    /> */}
                  <Autocomplete
                    multiple
                    id="free-solo-with-text-demo"
                    options={reasonDatas.map((option) => option.title)}
                    freeSolo
                    renderTags={(value: readonly string[], getTagProps) =>
                      value.map((option: string, index: number) => (
                        <Chip
                          variant="outlined"
                          label={option}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    // onInputChange={(event, newInputValue) => {
                    //     addValue(newInputValue);
                    // }}
                    // onInputChange={(event, newInputValue) => {
                    //     addValue(newInputValue);
                    // }}
                    onChange={(event: any, newValue: string | null) => {
                      addValue(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={"Reason"}
                        onKeyDown={handleKeyDown}
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography
                    sx={{ paddingTop: "1.5rem", alignItems: "center" }}
                  >
                    Description
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextAreaComponents
                    label={"Description"}
                    value={textFieldValue}
                    id={1}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                  <div
                    className="d-flex justify-content-end"
                    style={{ gap: "10px" }}
                  >
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        props.onClose(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        SetOpenSweetModal(true);
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default CancelReasonDialog;
